import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import TipoDocumentoSunat from 'constants/tiposDeDocumentoSunat'

import { KeyEventUtil } from 'utils'

const TipoDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-serieDocumento', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='TIPO DOC' htmlFor='select-tipoDocumento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='tipoDocumento'>
          {({ field }) => (
            <Form.Select {...field} id='select-tipoDocumento' disabled={fIsSubmitting} isInvalid={iTouched && iError} onKeyDown={onKeyDown}>
              {TipoDocumentoSunat.__ingresoAlmacenPorOrdenCompraArray.map((x, k) => (
                <option key={k} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
